<template>
  <!--坐标上传组件 -->
  <el-dialog
    title="上传坐标shp"
    style="color:white"
    :visible.sync="dialogFormVisible"
    append-to-body
    custom-class="mainDialog"
  >
    <div class="infobody">
      <div><span>1、请确保您上传的shp文件为WGS-84坐标系；</span></div>
      <div><span>2、上传文件至少包含：.dbf、.shp、.shx、.prj文件</span></div>
      <div class="upfile">
        <el-upload
          class="upload-demo"
          ref="upload"
          name="file"
          action="/dmc/file/uploadFile"
          :on-preview="handlePreview"
          :on-change="handleChange"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :before-upload="beforupload"
          :auto-upload="false"
          :on-progress="handlerogress"
          :on-success="successCallBack"
          :on-exceed="handleExceed"
          multiple
          :limit="4"
          accept=".dbf,.shp,.shx,.prj"
          :file-list="fileList"
        >
          <el-button
            type="success"
            size="mini"
            class="cshi"
          >选择文件</el-button>
        <el-button
            type="success"
            size="mini"
            @click.stop="clearFiles"
          >清空列表</el-button>
        </el-upload>
      </div>
    </div>
    <div style="margin-top: 20px;text-align: center;">
      <el-button
        class="buttongtey"
        type="primary"
        @click="upload"
      >确 定</el-button>
      <el-button
        style="margin-left: 60px;"
        class="buttongteys"
        @click="dialogFormVisible = false"
      >取 消</el-button>

    </div>

  </el-dialog>
</template>

<script>
import Map from '../../common/map/Tmap.js'
import store from '../../vuex/index.js'
export default {
  name: 'HeadUpdataDialog',
  props: ['msgFather', 'prodata'],
  data () {
    return {
      dialogFormVisible: false,
      leftvalue: '',
      rightvalue: '',
      topvalue: '',
      downvalue: '',
      fileList: []
    }
  },
  created () {

  },
  methods: {
    upload () {
      if (this.fileList.length !== 4) {
        this.$message.warning(`必须选择 4 个文件，本次选择了 ${this.fileList.length} 个文件`)
        return
      }
      this.$refs.upload.submit()
      this.dialogFormVisible = false
      var drawstyle4 = '上传坐标'
      document.getElementById('drawstyle4').innerHTML = drawstyle4
      document.getElementById('drawstyle1').innerHTML = ''
      document.getElementById('fooderxzqy').innerHTML = ''
      document.getElementById('drawstyle2').innerHTML = ''
      document.getElementById('drawstyle3').innerHTML = ''
    },
    sendMsgToParent: function () {
      this.$emit('getupdatadialogFormVisible', this.dialogFormVisible)
    },
    handleRemove: function (file, fileList) {
    },
    handlePreview: function (file) {
    },

    handleExceed: function (files, fileList) {
      this.$message.warning(`当前限制选择 4 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove: function (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    handleChange: function (file, fileList) {
      this.fileList = fileList
    },
    beforupload: function (file) {
    },
    handlerogress: function (event, file, fileList) {
    },
    // 文件上传成功之后的处理函数
    successCallBack(response, file, fileList) {
      if (file.name.endsWith('.shp')) {
        if (response.retCode === '0') {
          this.$message.success('文件上传成功')
          Map.AddWKT2Source(response.wkt, true)
          store.commit('setDrawgeometry', response.wkt)
          this.$emit('getQueryType', '3')
          localStorage.setItem('queryType', '3')
          this.$emit('getRange', 'custom')
        } else {
          this.$message.warning(response.retMsg)
        }
      }
    },
    // 清空上传列表
    clearFiles() {
      this.$refs.upload.clearFiles()
    }
  },
  watch: {
    msgFather: function (curVal) {
      this.dialogFormVisible = curVal
    },
    dialogFormVisible: function () {
      this.sendMsgToParent()
    }
  }
}
</script>
<style scoped>
.el-button--success {
  margin-left: 15px;
  color: #fff;
  background-color: #18bc9c;
  border-color: #18bc9c;
}
.cshi {
  padding: 7px 7px;
}
.upfile {
  margin-top: 20px;
}
.infobody {
  width: 90%;
  margin-left: 5%;
  margin-top: 5px;
  display: flex;
  flex-flow: column;
  text-align: start;
  line-height: 2;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-top: 30px;
}
.el-dialog__header {
  background: #1d202f;
  border-radius: 8px 8px 0 0;
  height: 1.25rem;
}
.dialog__header span {
  color: white;
}
.el-dialog {
  position: relative;
  margin: 0 auto 50px;
  border-radius: 8px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/components/HeadMenu/HeadUpdataDialog.vue